/** Normalize phone — strip spaces / common separators */
export function normalizePhoneDigits(phone: string): string {
  return phone.replace(/[\s\-().]/g, "").trim();
}

/** แปลงเบอร์ลาว → รูปแบบ wa.me (ไม่มี +) */
export function formatPhoneForWhatsApp(phone: string): string | null {
  const digits = normalizePhoneDigits(phone).replace(/\D/g, "");
  if (!digits) return null;

  if (digits.startsWith("856")) return digits;
  if (digits.startsWith("20")) return `856${digits}`;
  if (digits.startsWith("0")) return `856${digits.slice(1)}`;
  // Lao mobile without prefix, e.g. 96619695 → 8562096619695
  if (digits.length === 8) return `85620${digits}`;

  return digits.length >= 8 ? digits : null;
}

export function buildWhatsAppChatUrl(
  phone: string,
  message?: string,
): string | null {
  const waPhone = formatPhoneForWhatsApp(phone);
  if (!waPhone) return null;

  const base = `https://wa.me/${waPhone}`;
  const text = message?.trim();
  if (!text) return base;

  return `${base}?text=${encodeURIComponent(text)}`;
}

export function buildPerformanceRequestWhatsAppUrl(input: {
  phone: string;
  contactName?: string | null;
  requestTitle?: string | null;
}): string | null {
  const name = input.contactName?.trim();
  const title = input.requestTitle?.trim();
  const greeting = name ? `ສະບາຍດີ ${name}` : "ສະບາຍດີ";
  const about = title ? ` ກ່ຽວກັບຄຳຂໍ: ${title}` : "";
  const message = `${greeting} — ທີມ Fanglao Studio ຕິດຕໍ່${about}`;

  return buildWhatsAppChatUrl(input.phone, message);
}
